import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";

const CustomDropdownNoSearch = ({
  options,
  value,
  onChange,
  label,
  placeholder = "Select an option",
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(value || "");
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (value) {
      setSelectedOption(value);
    }
  }, [value]);

  const handleOptionChange = (option) => {
    setSelectedOption(option);
    onChange(option);
    setDropdownOpen(false);
  };

  // Close dropdown on outside click or Escape key press
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    const handleEscapeKey = (event) => {
      if (event.key === "Escape") {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscapeKey);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, []);

  return (
    <div className="relative w-full" ref={dropdownRef}>
      {label && (
        <label className="block text-sm font-medium text-agLightGray mb-1">
          {label}
        </label>
      )}
      <div
        className="flex items-center border rounded-md px-3 py-3 focus-within:outline-none focus-within:border-agPrimary cursor-pointer"
        onClick={() => setDropdownOpen((prev) => !prev)}
      >
        <span
          className={`text-sm ${
            selectedOption ? "text-agBlack" : "text-agLightGray"
          }`}
        >
          {selectedOption || placeholder}
        </span>
        <span className="material-icons-round ml-auto">arrow_drop_down</span>
      </div>
      {dropdownOpen && (
        <div className="absolute z-10 mt-2 w-full bg-white border border-agGray rounded-md shadow-lg max-h-60 overflow-auto">
          <ul>
            {options.map((option, index) => (
              <li
                key={index}
                className="text-sm text-agBlack px-3 py-2 hover:bg-agPrimaryLight cursor-pointer"
                onClick={() => handleOptionChange(option)}
              >
                {option}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

CustomDropdownNoSearch.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
};

export default CustomDropdownNoSearch;
